import * as types from 'constants/ActionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @type {import('modules/global/generic.types.js').Page} */
const initialState = {
  number: 0,
  totalElements: 0,
  totalPages: 0,
  size: 10,
};

/**
 * @param {import('modules/global/generic.types.js').Page} _
 * @param {import('modules/statistics/types').FetchTopContributorsStatsSuccessAction} action
 * @returns {import('modules/global/generic.types.js').Page}
 */
const updateAllData = (_, { payload }) => payload.page;

export default createReducer(initialState, {
  [types.FETCH_STATISTICS_TOP_CONTRIBUTORS_SUCCESS]: updateAllData,
});
